import * as React from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';

function valuetext(value) {
  return value;
}

// const MINIMUM_AGE = 18;
export default function RangeSlider({ value, setValue, min, max }) {
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Slider
        getAriaLabel={() => 'range'}
        value={value}
        onChange={handleChange}
        valueLabelDisplay='on'
        getAriaValueText={valuetext}
        color='secondary'
        min={min}
        max={max}
      />
    </Box>
  );
}
